import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@app/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  
//    canActivate(): boolean | UrlTree {
//   if (this.authService.isAuthenticated()) {
//     return true; // allow access
//   }

//   const currentUrl = this.router.getCurrentNavigation()?.finalUrl?.toString() || this.router.url;

  

//   return this.router.createUrlTree(['/login'], {
//     queryParams: { redirectTo: currentUrl },
//   });
// }

 canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    // ✅ ALWAYS correct current URL
    const redirectUrl = state.url;

    return this.router.createUrlTree(['/login'], {
      queryParams: { redirectTo: redirectUrl },
    });
  }

}
